// Catch-all inside the content area: the shell stays; one sentence + the way home.

import { Link } from 'react-router-dom';
import { EmptyState } from '@/components/EmptyState';
import { HOME_PATH } from './Forbidden';

export function NotFound() {
  return (
    <EmptyState
      data-testid="not-found"
      title="الصفحة غير موجودة."
      action={
        <Link className="e-btn e-btn--line e-btn--md" to={HOME_PATH}>
          اليوم
        </Link>
      }
    />
  );
}
